import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { GET_LOCATION_MONTHLY_WASTE_URL } from "../middleware/routes";
import { RootState } from "../store";
import { IMonthlyWeightItem, IMonthlyWeightState } from "../types/monthlyWasteWeight";
import { Status } from "../types/state";
import { axiosRequestApi } from "../utils/axiosRequest";

const initialState: IMonthlyWeightState = {
  status: Status.idle,
  data: [],
  errorMsg: null,
  requestId: "",
};

export const monthlyWasteWeightSlice = createSlice({
  name: "monthlyWasteWeight",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMonthlyWeightThunk.pending, (state, action) => {
        state.status = Status.requesting;
        state.data = [];
        state.errorMsg = null;
        state.requestId = action.meta.requestId;
      })
      .addCase(getMonthlyWeightThunk.fulfilled, (state, action) => {
        if (state.requestId !== action.meta.requestId) {
          return;
        }

        state.status = Status.success;
        state.data = action.payload;
        state.requestId = "";
      })
      .addCase(getMonthlyWeightThunk.rejected, (state, action) => {
        if (state.requestId !== action.meta.requestId) {
          return;
        }
        state.status = Status.error;
        state.errorMsg = "Failed to fetch monthly waste weight data";
        state.requestId = "";
      });
  },
});

export const getMonthlyWeightThunk = createAsyncThunk<IMonthlyWeightItem[], void, { state: RootState }>(
  "monthlyWasteWeight/getMonthlyWeight",
  async (_, { getState }) => {
    const state = getState();
    const year = state.application.years.selectedYear.value;

    const { data } = await axiosRequestApi.get<IMonthlyWeightItem[]>(`${GET_LOCATION_MONTHLY_WASTE_URL}/${year}`);

    return data;
  }
);

export const monthlyWasteWeightReducer = monthlyWasteWeightSlice.reducer;
